import { IdField } from '../../core/ts-decorators/model-decorators';

export interface IProfilesState {
  profiles: Profile[];
  profileOverview: Profile;
  profileProperties: Profile;
  profilePermissions: Permission[];
  availablePermissions: Permission[];
  shortNames: ShortNameTypes[];
  isCreateProfileDialogVisible: boolean;
  isAssignPermissionsDialogVisible: boolean;
  permissionTypes : PermissionType[]
}

export class Profile {
  @IdField()
  id: number = 0;
  profileName: string = '';
  description: string = '';
  createdAt: string = '';
  updatedAt: string = '';
  createdBy?: number = undefined;
  createdByName?: string = undefined;
  updatedBy?: number = undefined;
  updatedByName?: string = undefined;
  permissions : Permission[] = [];

  get idProfile(): number {
    return this.id;
  }

  set idProfile(value: number) {
    this.id = value;
  }

  get name(): string {
    return this.profileName;
  }

  set name(value: string) {
    this.profileName = value;
  }
}

export class ProfilePermissions {
  @IdField()
  description: string = '';
  permission: number = 0;
  permissionName: string = '';
  permissionText: string = '';
  shortName: string = '';
}

export class Permission {
  @IdField()
  id: number = 0;
  key: string = '';
  type: string = '';
  name: string = '';
}

export interface ShortNameTypes {
  value: string;
  label: string;
}
export interface PermissionType {
  permission : string 
}
